import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { FormDataService } from '../data.service';
import { formStatuses } from 'app/form/form.constants';
import { FormShareService } from '../share.service';

@Injectable()
export class CompleteReviewFormActionHandlerService extends FormActionHandlerService {
  constructor(
    private dataService: FormDataService,
    private shareService: FormShareService,
    private statusService: FormStatusService,
    private swal: SwalService
  ) {
    super();
  }

  // This action should only be available to managers
  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      // => whenever form is saved for first time, it is automatically received
      that.shareService.form.addReceivedDate();

      // Status also automatically gets set to 'Review Complete' since it is a manager
      // who inputs the data to begin with
      that.swal.load('Changing Status to Review Complete');
      that.statusService.changeStatus(formStatuses.reviewComplete.name);

      // Save the form
      that.dataService.saveForm().subscribe(
        successfulSave => {
          that.swal
            .success({
              title: 'Success',
              text: 'Form has been successfully submitted !'
            })
            .then(resolve)
            .catch(resolve);
        },
        errorSaving => {
          if (errorSaving === 409) {
            reject(errorSaving);
          } else {
            reject(
              'We were unable to submit your form. Please try again later.'
            );
          }
        }
      );
    });
  }
}
